import { Truck } from "@phosphor-icons/react";
import { fieldOrDash } from "@/components/orders/orderDetailUtils";

export default function ShippingCard({ order }) {
  return (
    <div className="border border-black bg-white">
      <div className="border-b border-black p-4 flex items-center gap-2"><Truck size={16} weight="bold" /><div className="overline text-zinc-500">ENVIO</div></div>
      <div className="p-5 space-y-2 text-sm">
        <div className="flex justify-between"><span className="text-zinc-500">Frete por conta</span><span>{fieldOrDash(order.freight_responsible)}</span></div>
        <div className="flex justify-between"><span className="text-zinc-500">Transportadora</span><span>{fieldOrDash(order.shipping_carrier)}</span></div>
        <div className="flex justify-between"><span className="text-zinc-500">Rastreamento</span><span className="font-mono text-xs">{fieldOrDash(order.tracking_code)}</span></div>
        <div className="flex justify-between"><span className="text-zinc-500">Vendedor</span><span>{fieldOrDash(order.seller)}</span></div>
      </div>
    </div>
  );
}
